const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

export const formatCurrency = (value: number | null | undefined) =>
  value == null ? '—' : formatter.format(value)
